<div class="rules">
  <p>{{ "footers.domainRulesShortDescription" | translate }}</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "footers.domainRulesMatchMode" | translate }}</mat-label>
    <mat-select [formControl]="form.controls.domainRulesMatchMode">
      <mat-option value="ANY_RECIPIENT">
        {{ "footers.domainRulesMatchModeAny" | translate }}
      </mat-option>
      <mat-option value="ALL_RECIPIENTS">
        {{ "footers.domainRulesMatchModeAll" | translate }}
      </mat-option>
      <mat-option value="INSTALL_ANY">
        {{ "footers.domainRulesMatchModeInstallOnly" | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "footers.domainRules" | translate }}</mat-label>
    <textarea
      matInput
      [formControl]="form.controls.domainRules"
      [placeholder]="'footers.domainRulesPlaceholder' | translate"
      [disabled]="isInstallOnlyMode"
      rows="3"
    ></textarea>
    <mat-hint>{{ "footers.domainRulesDescription" | translate }}</mat-hint>
  </mat-form-field>

  <mat-checkbox
    [formControl]="form.controls.domainRulesIgnoreSenderDomain"
    [disabled]="isInstallOnlyMode"
    color="primary"
  >
    {{ "footers.domainRulesIgnoreSenderDomain" | translate }}
  </mat-checkbox>

  <div class="domain-rules-actions">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="disabled || saving || !form.dirty">
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="saving"></mat-spinner>
      <mat-icon *ngIf="!saving">rule</mat-icon>
      {{ saving ? ("saving" | translate) : ("footers.updateDomainRules" | translate) }}
    </button>
  </div>
</div>
